export default "__VITE_ASSET__WvT_8Uxd__"